import {
  getFrontNotifiche,
  getGetFrontNotificheQueryKey,
  useGetFrontNotifiche,
  usePostFrontNotificheIdPresaVisione,
  usePutFrontNotificheAzioneMassivaRegistraLetturaNotificheCompleto,
} from '@framework/api-client/api/inquiries-compile/notifiche/notifiche.ts';
import { ReadAllNotificationsLogic } from '@framework/common-web/schema/notifications/ReadAllNotificationsLogic.ts';
import {
  type INotificationsContext,
  NotificationsContextProvider,
} from '@framework/common-web/ui/notification/context/NotificationsContext.tsx';

export interface IFrontNotificationWrapperProps {
  children?: React.ReactNode;
}

/**
 * Componente che fornisce il contesto per la gestione delle notifiche in Frontoffice,
 * utilizzando le API di Frontoffice per ottenere e gestire le notifiche.
 * Deve essere posizionato in un punto alto della gerarchia dei componenti
 * per permettere a tutti i componenti figli di accedere al contesto delle notifiche.
 */
export function FrontNotificationWrapper(
  props: IFrontNotificationWrapperProps,
) {
  const { children } = props;
  const contextValue: INotificationsContext = {
    useGetNotifications: useGetFrontNotifiche,
    useMarkAsRead: usePostFrontNotificheIdPresaVisione,
    getGetNotificationsQueryKey: getGetFrontNotificheQueryKey,
    getNotifications: getFrontNotifiche,
    useMarkAllAsRead: ReadAllNotificationsLogic.isVisible()
      ? usePutFrontNotificheAzioneMassivaRegistraLetturaNotificheCompleto
      : null,
  };

  return (
    <NotificationsContextProvider {...contextValue}>
      {children}
    </NotificationsContextProvider>
  );
}
